module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_5010.90f82a93.png";